import { Card, Heading, Text } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'
import Accordion from './components/Accordion'
import FAQ_DATA from './data'

const IconInfo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    width="13px"
    height="13px"
    style={{ verticalAlign: 'middle', margin: '0 5px 0 0' }}
  >
    <g id="_x31_72_Infos">
      <path d="M12.34 1.71c-5.51 0-10 4.49-10 10s4.49 10 10 10 10-4.49 10-10-4.49-10-10-10zm0 19.05c-4.99 0-9.05-4.06-9.05-9.05s4.06-9.05 9.05-9.05 9.05 4.06 9.05 9.05-4.06 9.05-9.05 9.05z"></path>
      <path d="M12.58 8.5c-.68 0-1.24.53-1.27 1.22L10.99 18c-.01.39.13.76.4 1.04s.63.43 1.02.43h.33c.39 0 .75-.15 1.02-.43s.41-.64.4-1.03l-.31-8.29c-.03-.68-.59-1.22-1.27-1.22zm.49 9.88a.47.47 0 01-.33.14h-.33c-.13 0-.25-.05-.34-.14a.467.467 0 01-.13-.34l.32-8.28c.01-.17.14-.3.31-.3.17 0 .31.13.31.3l.27 6.93.04 1.36c.02.12-.03.24-.12.33zm-.48-10.42c.41 0 .78-.15 1.07-.44.29-.29.44-.66.44-1.09 0-.42-.15-.79-.45-1.07a1.56 1.56 0 00-2.13 0c-.29.28-.45.65-.45 1.07 0 .43.15.8.44 1.09.3.29.67.44 1.08.44zm-.4-1.91c.11-.11.24-.16.4-.16s.29.05.4.16c.11.1.16.22.16.39s-.05.31-.16.41c-.22.22-.58.22-.8 0a.542.542 0 01-.16-.41c0-.17.05-.29.16-.39z"></path>
    </g>
  </svg>
)

const Faq = () => {
  const openChatBot = () => {
    window.ChatWidget.open()
  }

  return (
    <Card title="Dúvidas">
      <Heading size="mega">Perguntas frequentes</Heading>

      <S.FaqList>
        {FAQ_DATA.questions.map((item, index) => (
          <S.FaqItem key={index}>
            <article>
              <Accordion
                title={`${index + 1}. ${item.title}`}
                content={item.content}
              />
            </article>
          </S.FaqItem>
        ))}
      </S.FaqList>

      <S.ContactsContainer>
        <Text bold>Ainda com dúvidas?</Text>

        <S.ContainerFlex>
          <div>
            <Text size="kilo" bold noMargin>
              Ligue na Central de Atendimento
            </Text>
            <Text size="kilo">Das 8h às 19h de segunda a sábado.</Text>

            <S.Contact>
              <Text size="giga" bold noMargin>
                <a tel="tel:4020-5376">4020-5376</a>
              </Text>
              <Text size="kilo" noMargin>Capitais</Text>
            </S.Contact>

            <S.Contact>
              <Text size="giga" bold noMargin>
                <a tel="tel:0800-020-5376">0800-020-5376</a>
              </Text>
              <Text size="kilo" noMargin>Outras regiões</Text>
            </S.Contact>
          </div>

          <S.Separator />

          <S.ContainerAssistant>
            <Text size="kilo" noMargin>
              Fale com a nossa Assistente Virtual
            </Text>
            <Text size="kilo" noMargin>
              Faça sua pergunta para a Lia
            </Text>

            <S.ButtonChatBot onClick={openChatBot} />
          </S.ContainerAssistant>
        </S.ContainerFlex>
      </S.ContactsContainer>

      <div>
        <Text size="kilo" noMargin>
          <IconInfo /> Para mais detalhes sobre as regras acesse o{' '}
          <a
            href="https://www.leroymerlin.com.br/institucional/regulamento-programa-leroy-merlin-com-voce"
            target="_blank"
          >
            Regulamento do Programa
          </a>
        </Text>
      </div>
    </Card>
  )
}

export default Faq
